import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const getZoneColor = (index) => {
    if (index < 60)
        return "#dc2626";
    if (index < 80)
        return "#f59e0b";
    return "#16a34a";
};
const CoherenceMeter = ({ value }) => {
    const clamped = Math.max(0, Math.min(100, value));
    const activeBars = Math.round(clamped);
    return (_jsxs("div", { style: { width: "100%", maxWidth: 420 }, children: [_jsxs("div", { style: {
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: 14,
                    marginBottom: 8,
                    color: "#111827",
                }, children: ["Match Confidence: ", clamped.toFixed(0), "%"] }), _jsxs("div", { style: {
                    textAlign: "center",
                    fontSize: 11,
                    fontWeight: 400,
                    color: "#6b7280",
                    marginBottom: 8,
                    marginTop: -4,
                }, children: ["Indicates alignment between uploaded documents and the blueprint", _jsx("div", { style: { position: "relative", width: "100%" }, children: _jsx("div", { style: {
                                display: "flex",
                                gap: 2,
                                justifyContent: "space-between",
                            }, children: Array.from({ length: 100 }).map((_, i) => (_jsx("div", { style: {
                                    width: 3,
                                    height: 14,
                                    borderRadius: 1,
                                    backgroundColor: i < activeBars ? getZoneColor(i) : "#e5e7eb",
                                    transition: "background-color 0.3s ease",
                                } }, i))) }) })] })] }));
};
export default CoherenceMeter;
